module.exports = __webpack_public_path__ + "img/icon-clock.14bdb1da.svg";